import { DashboardTile } from "../components/DashboardTile";
import { TileHeader } from "../components/TileHeader";
import { useMemo } from "react";
import { useTotalPointsQuery } from "@common/utils/graphql";
import { Skeleton } from "@/components/ui/skeleton";
import commaNumber from "comma-number";
import { Body } from "@hypercard/web-components";
import { twMerge } from "@/utils/utils";

type Props = {
  className?: string;
};

export const PointsTile = ({ className }: Props) => {
  const {
    loading: pointsLoading,
    data: pointsData,
    error,
  } = useTotalPointsQuery();

  const points = useMemo(() => {
    if (pointsData?.totalPoints?.__typename !== "QueryTotalPointsSuccess") {
      return undefined;
    }
    return pointsData?.totalPoints?.data;
  }, [pointsData]);

  const pointsText = (
    <div>
      {commaNumber(Number(points || 0))}{" "}
      <span className="text-2xl font-[400]">pts</span>
    </div>
  );

  return (
    <DashboardTile
      className={twMerge(
        "flex min-h-[250px] flex-col justify-between",
        className,
      )}
    >
      <TileHeader>POINTS</TileHeader>
      {error ? (
        <div className="flex h-full w-full flex-col items-center justify-center pb-8">
          <Body size="sm" weight="medium" className="text-center">
            Failed to load points
          </Body>
        </div>
      ) : (
        <div className="flex flex-col justify-center space-y-4">
          <div className="font-serif text-[40px] font-medium">
            {pointsLoading ? (
              <Skeleton className="h-4 w-[200px]" />
            ) : (
              pointsText
            )}
          </div>
          <div className="text-sm text-slate">
            2x points for every dollar spent
          </div>
        </div>
      )}
    </DashboardTile>
  );
};
